import type {Department, Document} from 'src/typings';
import type ExemplarService from '../exemplar.service';

export class KpExemplarsPresenter {
    public static presenterName = 'kpExemplarsPresenter';

    /*@ngInject*/
    constructor(private exemplarService: ExemplarService) {
    }

    public async createExemplar(document: Document, department: Department) {
        await this.exemplarService.createExemplarByFormAndReload(document, department);
    }
}